import { render, staticRenderFns } from "./GroupAssignmentGrid.vue?vue&type=template&id=2198812a"
import script from "./GroupAssignmentGrid.vue?vue&type=script&lang=js"
export * from "./GroupAssignmentGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports